import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_AWS_ALL_RESOURCE_ALERTS,
  GET_CLOUD_RESOURCES,
  POST_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  POST_UPDATE_RESOURCE_ENVIRONMENT,
  GET_AWS_ALL_RESOURCE_ALERTS_PAGE,
  GET_ALL_ORG_AWS_RESOURCE_TYPES, POST_RESOURCE_SERVICE_MAPPING,
  GET_AWS_ALL_RESOURCE_COUNT,
  GET_AWS_APPSYNC_DATA_SOURCES_ALERTS,
  GET_AWS_APPSYNC_DATA_SOURCES_COUNT,
  GET_AWS_APPSYNC_RESOLVERS_COUNT,
  GET_AWS_APPSYNC_RESOLVERS_ALERTS,
  GET_USER_RESCAN_STATUS
} from "./actionTypes";

import {
  getAWSAllResourceAlertsSuccess,
  getAWSAllResourceAlertsFail,
  getCloudResourcesSuccess,
  postResourceOpsGenieTeamMappingFail,
  postResourceOpsGenieTeamMappingSuccess,
  postResourcePagerdutyServiceMappingFail,
  postResourcePagerdutyServiceMappingSuccess,
  postUpdateResourceEnvironmentSuccess,
  postUpdateResourceEnvironmentFail,
  getAWSAllResourceAlertsPageSuccess,
  getAWSAllResourceAlertsPageFail,
  getAllOrgAWSResourceTypesSuccess,
  getAllOrgAWSResourceTypesFail,
  postResourceServiceMappingSuccess,
  postResourceServiceMappingFail,
  getAWSResourceCountSuccess,
  getAWSResourceCountFail,
  getAWSAppsyncDataSourceCountFail,
  getAWSAppsyncDataSourceCountSuccess,
  getAWSAppSyncDataSourcesAlertsPageSuccess,
  getAWSAppSyncDataSourcesAlertsPageFail,
  getAWSAppSyncResolversAlertsPageSuccess,
  getAWSAppSyncResolversAlertsPageFail,
  getAWSAppsyncResolversCountSuccess,
  getAWSAppsyncResolversCountFail,
  getAwsRefreshScanStatusSuccess,
  getAwsRefreshScanStatusFail
} from "./actions";

import {
  getAllOrgAWSResourceTypesUrl,
  getAWSAllResourceAlertsPageUrl,
  getAWSAllResourceCountPageUrl,
  getAWSAllResourceAlertsUrl,
  getCloudResources,
  postResourceOpsgenieTeamMapping,
  postResourcePagerdutyServiceMappingCall,
  postUpdateResourceEnvironmentUrl,
  postServiceMapping,
  getRescanStatusAwsUrl,
} from "../../helpers/fakebackend_helper";
import {showNotification} from "../../components/Common/notification";


function* onGetAwsAllResourceAlerts() {
  try {
    const response = yield call(getAWSAllResourceAlertsUrl);
    yield put(getAWSAllResourceAlertsSuccess(response));
  } catch (error) {
    yield put(getAWSAllResourceAlertsFail(error.message));
  }
}

function* onGetAwsAllResourceAlertsPage({ payload: { page_filters } }) {
  try {
    const response = yield call(getAWSAllResourceAlertsPageUrl, page_filters);
    yield put(getAWSAllResourceAlertsPageSuccess(response));
  } catch (error) {
    yield put(getAWSAllResourceAlertsPageFail(error.message));
  }
}

function* onGetAwsAllResourceCountPage({ payload: { page_filters } }) {
  try {
    const response = yield call(getAWSAllResourceCountPageUrl, page_filters);
    yield put(getAWSResourceCountSuccess(response));
  } catch (error) {
    yield put(getAWSResourceCountFail(error.message));
  }
}

function* onGetAllOrgAWSResourceTypes() {
  try {
    const response = yield call(getAllOrgAWSResourceTypesUrl);
    yield put(getAllOrgAWSResourceTypesSuccess(response));
  } catch (error) {
    yield put(getAllOrgAWSResourceTypesFail(error.message));
  }
}

function* onPostResourceOpsgenieTeamMapping({ payload: { resource_team_mapping } }) {
  try {
    const response = yield call(postResourceOpsgenieTeamMapping, resource_team_mapping);
    yield put(postResourceOpsGenieTeamMappingSuccess(response));
  } catch (error) {
    yield put(postResourceOpsGenieTeamMappingFail(error.message));
  }
}

function* onPostResourcePagerdutyServiceMapping({ payload: { resource_service_mapping } }) {
  try {
    const response = yield call(postResourcePagerdutyServiceMappingCall, resource_service_mapping);
    yield put(postResourcePagerdutyServiceMappingSuccess(response));
  } catch (error) {
    yield put(postResourcePagerdutyServiceMappingFail(error.message));
  }
}

function* onPostResourceServiceMapping({ payload: { resource_service_mapping } }) {
  try {
    const response = yield call(postServiceMapping, resource_service_mapping);
    yield put(postResourceServiceMappingSuccess(response));
  } catch (error) {
    yield put(postResourceServiceMappingFail(error.message));
  }
}

function* onGetCloudResources() {
  const response = yield call(getCloudResources);
  yield put(getCloudResourcesSuccess(response));
}

function* onPostUpdateResourceEnvironment({ payload: { resource_environment } }) {
  try {
    const response = yield call(postUpdateResourceEnvironmentUrl, resource_environment);
    yield put(postUpdateResourceEnvironmentSuccess(response));
  } catch (error) {
    yield put(postUpdateResourceEnvironmentFail(error.message));
  }
}

function* onGetAwsAppsyncDataSourcesAlertsPage({ payload: { page_filters } }) {
  try {
    const response = yield call(getAWSAllResourceAlertsPageUrl, page_filters);
    yield put(getAWSAppSyncDataSourcesAlertsPageSuccess(response));
  } catch (error) {
    yield put(getAWSAppSyncDataSourcesAlertsPageFail(error.message));
  }
}

function* onGetAwsAppsyncDataSourcesCount({ payload: { page_filters } }) {
  try {
    const response = yield call(getAWSAllResourceCountPageUrl, page_filters);
    yield put(getAWSAppsyncDataSourceCountSuccess(response));
  } catch (error) {
    yield put(getAWSAppsyncDataSourceCountFail(error.message));
  }
}

function* onGetAwsAppsyncResolversAlertsPage({ payload: { page_filters } }) {
  try {
    const response = yield call(getAWSAllResourceAlertsPageUrl, page_filters);
    yield put(getAWSAppSyncResolversAlertsPageSuccess(response));
  } catch (error) {
    yield put(getAWSAppSyncResolversAlertsPageFail(error.message));
  }
}

function* onGetAwsAppsyncResolversCount({ payload: { page_filters } }) {
  try {
    const response = yield call(getAWSAllResourceCountPageUrl, page_filters);
    yield put(getAWSAppsyncResolversCountSuccess(response));
  } catch (error) {
    yield put(getAWSAppsyncResolversCountFail(error.message));
  }
}

function* onGetAwsRescanStatus() {
  try {
    const response = yield call(getRescanStatusAwsUrl);
    yield put(getAwsRefreshScanStatusSuccess(response));
  } catch (error) {
    yield put(getAwsRefreshScanStatusFail(error.message));
  }
}

function* cloudResourcesSaga() {
  yield takeEvery(GET_AWS_ALL_RESOURCE_ALERTS, onGetAwsAllResourceAlerts);
  yield takeEvery(GET_AWS_ALL_RESOURCE_ALERTS_PAGE, onGetAwsAllResourceAlertsPage);
  yield takeEvery(GET_AWS_ALL_RESOURCE_COUNT, onGetAwsAllResourceCountPage);
  yield takeEvery(GET_ALL_ORG_AWS_RESOURCE_TYPES, onGetAllOrgAWSResourceTypes);
  yield takeEvery(GET_CLOUD_RESOURCES, onGetCloudResources);
  yield takeEvery(POST_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostResourceOpsgenieTeamMapping);
  yield takeEvery(POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING, onPostResourcePagerdutyServiceMapping);
  yield takeEvery(POST_UPDATE_RESOURCE_ENVIRONMENT, onPostUpdateResourceEnvironment);
  yield takeEvery(POST_RESOURCE_SERVICE_MAPPING, onPostResourceServiceMapping);
  yield takeEvery(GET_AWS_APPSYNC_DATA_SOURCES_ALERTS, onGetAwsAppsyncDataSourcesAlertsPage);
  yield takeEvery(GET_AWS_APPSYNC_DATA_SOURCES_COUNT, onGetAwsAppsyncDataSourcesCount);
  yield takeEvery(GET_AWS_APPSYNC_RESOLVERS_ALERTS, onGetAwsAppsyncResolversAlertsPage);
  yield takeEvery(GET_AWS_APPSYNC_RESOLVERS_COUNT, onGetAwsAppsyncResolversCount);
  yield takeEvery(GET_USER_RESCAN_STATUS, onGetAwsRescanStatus);
}

export default cloudResourcesSaga;
